import { KlearDate } from '@klear/date'

export type CalendarQuarterJson = { year: number; quarter: number }

export class CalendarQuarter {
  readonly year: number
  readonly quarter: number

  private constructor(year: number, quarter: number) {
    this.year = year
    this.quarter = quarter
  }

  static of(quarter: CalendarQuarterJson): CalendarQuarter {
    return new CalendarQuarter(quarter.year, quarter.quarter)
  }

  static containing(date: KlearDate): CalendarQuarter {
    return new CalendarQuarter(date.yearValue, date.quarterValue)
  }

  get end(): KlearDate {
    return KlearDate.of(`${this.year}-${`${this.quarter * 3}`.padStart(2, '0')}-01`).endOf('month')
  }

  hasEnded(today: KlearDate = KlearDate.today()): boolean {
    return today.isAfter(this.end)
  }

  get label(): string {
    return `${this.year} Q${this.quarter}`
  }

  toPeriodEnd(): { year: number; quarter: 1 | 2 | 3 | 4 } {
    const { quarter } = this
    return { year: this.year, quarter: quarter === 1 || quarter === 2 || quarter === 3 ? quarter : 4 }
  }

  toJSON(): CalendarQuarterJson {
    return { year: this.year, quarter: this.quarter }
  }
}
